import { create } from 'zustand'

interface Lesson {
  lesson_id: string
}

interface LessonsState {
  unassignedLessons: Lesson[]
  requestedLessons: Lesson[]
  homeData: Record<string, any>
  matchingOption: any
  setMatchingOption: (matchingOption: any) => void
  setHomeData: (homeData: Record<string, any>) => void
  setUnassignedLessons: (unassignedLessons: Lesson[]) => void
  setRequestedLessons: (requestedLessons: Lesson[]) => void
  setFilterLesson: (lesson_id: string) => void
}

const useLessonsStore = create<LessonsState>((set) => ({
  unassignedLessons: [{ lesson_id: '' }],
  requestedLessons: [{ lesson_id: '' }],
  homeData: {},
  matchingOption: null,
  setMatchingOption: (matchingOption) => set({ matchingOption }),
  setHomeData: (homeData) => set({ homeData }),
  setUnassignedLessons: (unassignedLessons) => set({ unassignedLessons }),
  setRequestedLessons: (requestedLessons) => set({ requestedLessons }),
  setFilterLesson: (lesson_id) =>
    set((state) => ({
      requestedLessons: state.requestedLessons.filter((item) => item.lesson_id !== lesson_id),
    })),
}))

export default useLessonsStore
